import { send } from 'server';

export const validatePassword = ({ password }) => send({
    ID: 35574,
    responses: [35575, 35576],
    description: 'Validate password',
    password,
    errorLevel: 1
});
